/* remove the whole file when cleaning up com.atlassian.rm.jpo.transposition.portal-migration */

.entryOld {
	padding-bottom: 36px;
}

.entryOld:last-child {
	padding-bottom: 0;
	white-space: normal;
}

.heading {
	font-weight: bold;
	min-width: 350px;
	padding-bottom: 8px;
}
